import { useLocalParticipant } from "@livekit/components-react";
import { useTranslation } from "react-i18next";
import { CallTile } from "./CallTile";
import { SoloEmptyState } from "./SoloEmptyState";
import { useCallLayoutTier } from "../hooks/useCallLayoutTier";
import { useSpeakerStage } from "../hooks/useSpeakerStage";

/**
 * Speaker layout — one large main tile with everyone else below. On phones
 * the filmstrip is a left-aligned row of small cards (design's speaker
 * mobile: self-view tucked under the main tile). Desktop keeps the design's
 * `height:100` / `width:150` strip.
 */
export function SpeakerLayout() {
  const { t } = useTranslation();
  const tier = useCallLayoutTier();
  const isMobile = tier === "mobile";
  const { mainTrack, thumbnails, isSoloEmpty, speakingSids } = useSpeakerStage();
  const { localParticipant } = useLocalParticipant();

  return (
    <div className={`h-full flex flex-col ${isMobile ? "p-3 gap-2.5" : "p-4 lg:p-6 gap-3"}`}>
      <div className="flex-1 min-h-0">
        {isSoloEmpty && localParticipant ? (
          <SoloEmptyState participant={localParticipant} />
        ) : mainTrack ? (
          <CallTile
            trackRef={mainTrack}
            isSpeaking={speakingSids.has(mainTrack.participant.sid)}
            size="lg"
            className="h-full w-full"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-sm text-muted-foreground">
            {t("call.speaker.waitingForParticipants")}
          </div>
        )}
      </div>

      {thumbnails.length > 0 && (
        <div
          className={`flex overflow-x-auto no-scrollbar shrink-0 justify-start ${isMobile ? "gap-2.5" : "gap-3"}`}
          style={{ height: isMobile ? 88 : 100 }}
        >
          {thumbnails.map((trackRef) => (
            <div
              key={`${trackRef.participant.sid}-${trackRef.source}`}
              style={{ width: isMobile ? 128 : 150 }}
              className="shrink-0 h-full"
            >
              <CallTile
                trackRef={trackRef}
                isSpeaking={speakingSids.has(trackRef.participant.sid)}
                size="sm"
                className="h-full w-full"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
